export enum DepositPaymentType {
  CASH = 'cash',
  CHECK = 'check',
}
